import dayjs from 'dayjs';
import { CostForward, ExpenseStatus, IExpense } from '../interface/expense';
import { BorderColor, TagColor } from '../interface/common';

export interface IDailyGroupedExpenses {
  date: string;
  expenses: IExpense[];
}

export const groupExpensesByDay = (expensesData: IExpense[]): IDailyGroupedExpenses[] =>
  Object.values(
    expensesData.reduce((acc: Record<string, IDailyGroupedExpenses>, elem: IExpense) => {
      const elemKey = dayjs(elem.expenseDate).format('YYYY-MM-DD');
      if (!acc[elemKey]) {
        acc[elemKey] = { date: elem.expenseDate, expenses: [] };
      }

      acc[elemKey].expenses.push(elem);
      acc[elemKey].expenses.sort((a, b) => {
        return new Date(b.createdOn).valueOf() - new Date(a.createdOn).valueOf();
      });

      return acc;
    }, {}),
  ).sort((a, b) => {
    return new Date(b.date).valueOf() - new Date(a.date).valueOf();
  });
export enum ExpenseSections {
  general = 'general',
  notes = 'notes',
}
export const expenseStatusTranslationMapping = {
  [ExpenseStatus.APPROVED]: 'expense:status.approved',
  [ExpenseStatus.INVOICED]: 'expense:status.invoiced',
  [ExpenseStatus.NON_BILLABLE]: 'expense:status.nonBillable',
  [ExpenseStatus.OPEN]: 'expense:status.open',
  [ExpenseStatus.PRELIM_INVOICE]: 'expense:status.preliminaryInvoice',
  [ExpenseStatus.REVIEWED]: 'expense:status.reviewed',
};
export const expenseCostForwardTranslationMapping = {
  [CostForward.NO_COST_FORWARD]: 'expense:noCostForward',
  [CostForward.BY_PAYER_TAXABILITY]: 'expense:byPayerTaxability',
  [CostForward.BY_PURCHASE_TAXABILITY]: 'expense:byPurchaseTaxability',
};
export const borderColorMapping: {
  [key in ExpenseStatus]: string;
} = {
  [ExpenseStatus.OPEN]: BorderColor.GREEN,
  [ExpenseStatus.REVIEWED]: BorderColor.LIGHTBLUE,
  [ExpenseStatus.PRELIM_INVOICE]: BorderColor.BLUE,
  [ExpenseStatus.INVOICED]: BorderColor.YELLOW,
  [ExpenseStatus.NON_BILLABLE]: BorderColor.DARKGREY,
  [ExpenseStatus.APPROVED]: BorderColor.BEIGE,
};

export const tagColorMapping: {
  [key in ExpenseStatus]: TagColor;
} = {
  [ExpenseStatus.OPEN]: TagColor.GREEN,
  [ExpenseStatus.REVIEWED]: TagColor.LIGHTBLUE,
  [ExpenseStatus.PRELIM_INVOICE]: TagColor.BLUE,
  [ExpenseStatus.INVOICED]: TagColor.YELLOW,
  [ExpenseStatus.NON_BILLABLE]: TagColor.DARKGREY,
  [ExpenseStatus.APPROVED]: TagColor.BEIGE,
};
